import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAnnotationLines32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconAnnotationLines32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M22.5 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 2a4.5 4.5 0 1 0-3.825-2.129l-6.729 6.851a4.5 4.5 0 1 0 1.396 1.433l6.738-6.86A4.5 4.5 0 0 0 22.5 14m-13 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAnnotationLines32);
